import React, { useEffect, useMemo, useState, useCallback } from "react";
import Moment from "react-moment";
import AddPartnerUser from "./AddPartnerUser";
import ActiveDeactiveHistory from "./ActiveDeactiveHistory";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentUser, getLoggedUserDetails, loadUserDetails } from "../../app/store/auth";
import { useLoadPartnerUsersQuery } from "../../app/store/partnerApiSlice";
import { getFormatedNumber } from "../../Services/appService";
import { setCurrentPageTitle, setCurrentRoute } from "../../app/store/layoutUI";
import { getAlert } from "../../Services/appAlerts";
import AddEditPermission from "./AddEditPermission";

const MANAGE_USERS_STYLES = {
  shell: {
    fontFamily: '"Open Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    borderRadius: "20px",
    border: "1px solid rgba(226, 232, 240, 0.95)",
    backgroundColor: "#ffffff",
    boxShadow: "0 10px 30px rgba(15, 23, 42, 0.05)",
    overflow: "hidden",
    width: "100%"
  },
  hero: {
    padding: "18px 22px",
    borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
    background: "linear-gradient(135deg, #f8fafc 0%, #eff6ff 100%)"
  },
  heroRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "18px",
    flexWrap: "wrap"
  },
  heroCopy: {
    minWidth: "260px",
    flex: "1 1 480px"
  },
  heroTitleRow: {
    display: "flex",
    alignItems: "center",
    gap: "14px"
  },
  heroIcon: {
    width: "34px",
    height: "34px",
    borderRadius: "10px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#ffffff",
    color: "#2563eb",
    fontSize: "14px",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    boxShadow: "0 4px 12px rgba(37, 99, 235, 0.06)",
    flexShrink: 0
  },
  heroTitle: {
    fontSize: "18px",
    fontWeight: 600,
    lineHeight: 1.25,
    color: "#0f172a",
    margin: "0 0 3px 0",
    letterSpacing: "-0.01em"
  },
  heroText: {
    fontSize: "13px",
    lineHeight: 1.5,
    color: "#475569",
    margin: 0,
    maxWidth: "760px"
  },
  heroAction: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "8px",
    border: "1px solid #2563eb",
    background: "#2563eb",
    color: "#ffffff",
    padding: "9px 18px",
    fontSize: "13px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(37, 99, 235, 0.2)",
    cursor: "pointer",
    transition: "all 0.2s ease"
  },
  statGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "14px",
    padding: "20px 22px"
  },
  statCard: {
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
    backgroundColor: "#ffffff",
    border: "1px solid rgba(226, 232, 240, 0.95)",
    borderRadius: "16px",
    padding: "16px",
    boxShadow: "0 6px 18px rgba(15, 23, 42, 0.03)",
    transition: "all 0.2s ease"
  },
  statIcon: {
    width: "36px",
    height: "36px",
    borderRadius: "10px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#eff6ff",
    color: "#2563eb",
    fontSize: "14px",
    flexShrink: 0
  },
  statContent: {
    minWidth: 0
  },
  statLabel: {
    fontSize: "11px",
    fontWeight: 600,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#64748b",
    marginBottom: "4px"
  },
  statValue: {
    fontSize: "24px",
    fontWeight: 600,
    lineHeight: 1,
    color: "#0f172a",
    marginBottom: "4px"
  },
  statText: {
    fontSize: "12px",
    color: "#64748b",
    lineHeight: 1.4
  },
  panel: {
    backgroundColor: "#ffffff",
    border: "1px solid rgba(226, 232, 240, 0.95)",
    borderRadius: "20px",
    boxShadow: "0 10px 30px rgba(15, 23, 42, 0.05)",
    overflow: "hidden"
  },
  cardHeader: {
    padding: "18px 22px",
    borderTop: "1px solid rgba(226, 232, 240, 0.9)",
    borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
    background: "linear-gradient(135deg, #f8fafc 0%, #eff6ff 100%)"
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "16px",
    flexWrap: "wrap"
  },
  titleRow: {
    display: "flex",
    alignItems: "center",
    gap: "12px"
  },
  titleIcon: {
    width: "34px",
    height: "34px",
    borderRadius: "10px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#ffffff",
    color: "#2563eb",
    fontSize: "14px",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    boxShadow: "0 4px 12px rgba(37, 99, 235, 0.06)",
    flexShrink: 0
  },
  panelTitle: {
    fontSize: "18px",
    fontWeight: 600,
    color: "#0f172a",
    margin: 0
  },
  panelText: {
    fontSize: "12px",
    color: "#64748b",
    margin: 0
  },
  filterRow: {
    display: "flex",
    gap: "10px",
    flexWrap: "wrap",
    alignItems: "center"
  },
  inputWrap: {
    position: "relative"
  },
  inputIcon: {
    position: "absolute",
    left: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    color: "#64748b",
    fontSize: "13px"
  },
  searchInput: {
    paddingLeft: "34px",
    minWidth: "260px",
    borderRadius: "8px",
    border: "1px solid rgba(203, 213, 225, 0.9)",
    paddingTop: "9px",
    paddingBottom: "9px",
    fontSize: "13px",
    color: "#0f172a",
    outline: "none",
    backgroundColor: "#ffffff",
    boxShadow: "0 2px 8px rgba(15, 23, 42, 0.03)"
  },
  select: {
    minWidth: "150px",
    borderRadius: "8px",
    border: "1px solid rgba(203, 213, 225, 0.9)",
    padding: "9px 12px",
    fontSize: "13px",
    color: "#0f172a",
    outline: "none",
    backgroundColor: "#ffffff",
    boxShadow: "0 2px 8px rgba(15, 23, 42, 0.03)"
  },
  cardBody: {
    padding: "0"
  },
  tableWrap: {
    overflowX: "auto",
    backgroundColor: "#ffffff"
  },
  table: {
    width: "100%",
    marginBottom: 0,
    borderCollapse: "separate",
    borderSpacing: 0,
    fontSize: "13px",
    color: "#334155"
  },
  th: {
    borderTop: "1px solid rgba(226, 232, 240, 0.9)",
    fontSize: "11px",
    fontWeight: 600,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#64748b",
    background: "#f8fafc",
    borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
    padding: "14px 16px"
  },
  td: {
    padding: "14px 16px",
    borderBottom: "1px solid rgba(241, 245, 249, 1)",
    verticalAlign: "middle",
    fontWeight: 600
  },
  statusPill: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    padding: "6px 12px",
    borderRadius: "8px",
    fontSize: "12px",
    fontWeight: 600,
    border: "1px solid transparent"
  },
  rolePill: {
    display: "inline-flex",
    alignItems: "center",
    padding: "5px 12px",
    borderRadius: "8px",
    backgroundColor: "#eff6ff",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    color: "#1d4ed8",
    fontSize: "12px",
    fontWeight: 600
  },
  userName: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#0f172a",
    lineHeight: 1.2
  },
  userMeta: {
    fontSize: "12px",
    lineHeight: 1.45,
    color: "#64748b"
  },
  userCell: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    minWidth: "240px"
  },
  userAvatar: {
    width: "38px",
    height: "38px",
    borderRadius: "10px",
    background: "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)",
    color: "#ffffff",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "14px",
    fontWeight: 600,
    boxShadow: "0 4px 12px rgba(37, 99, 235, 0.15)",
    flexShrink: 0
  },
  actionBtn: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "8px",
    border: "1px solid #cbd5e1",
    background: "#ffffff",
    color: "#334155",
    padding: "9px 18px",
    fontSize: "13px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
    cursor: "pointer",
    transition: "all 0.2s ease",
    textDecoration: "none"
  },
  actionGroup: {
    display: "flex",
    gap: "8px",
    flexWrap: "wrap",
    alignItems: "center"
  },
  mutedAction: {
    fontSize: "12px",
    color: "#94a3b8",
    fontWeight: 600
  },
  emptyState: {
    padding: "32px 20px",
    textAlign: "center",
    color: "#64748b",
    fontSize: "14px"
  }
};

const ManagePartnerUsers = () => {
  const [actionType, setActionType] = useState("action");
  const [logShowHide, setLogShowHide] = useState(false);
  const [showHide, setShowHide] = useState(false);
  const [permissionShowHide, setPermissionShowHide] = useState(false);
  const [selectedObj, setSelectedObj] = useState("");
  const [selectedId, setSelectedId] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");

  const userDetails = useSelector(getLoggedUserDetails);

  const currentUser = useMemo(() => getCurrentUser(), []);
  const currentUserId = currentUser?.id;
  const dispatch = useDispatch();

  const partnerId = userDetails?.partnerid;

  // Load user details on mount if not already loaded
  useEffect(() => {
    if (!userDetails && currentUserId) {
      dispatch(loadUserDetails(currentUserId));
    }
  }, [dispatch, userDetails, currentUserId]);

  // RTK Query hook: load partner users when partnerId is available
  const { data: userList = [], refetch: refetchPartnerUsers } = useLoadPartnerUsersQuery(
    partnerId,
    { skip: !partnerId }
  );

  useEffect(() => {
    dispatch(setCurrentPageTitle("Manage Users"));
    dispatch(setCurrentRoute("Manage Users"));
  }, [dispatch]);

  const activeUsersCount = useMemo(
    () => userList.filter((item) => item.status === true).length,
    [userList]
  );
  const inactiveUsersCount = useMemo(
    () => userList.filter((item) => item.status === false).length,
    [userList]
  );
  const pendingUsersCount = useMemo(
    () => userList.filter((item) => item.status !== true && item.status !== false).length,
    [userList]
  );

  const filteredUsers = useMemo(() => {
    const searchLower = searchTerm.trim().toLowerCase();

    return userList.filter((item) => {
      const matchesSearch =
        !searchLower ||
        [
          item.id,
          item.name,
          item.lastName,
          item.email,
          item.title,
          item.state,
          item.contact
        ]
          .filter(Boolean)
          .some((val) => String(val).toLowerCase().includes(searchLower));

      const matchesStatus =
        statusFilter === "all" ||
        (statusFilter === "active" && item.status === true) ||
        (statusFilter === "inactive" && item.status === false) ||
        (statusFilter === "pending" && item.status !== true && item.status !== false);

      return matchesSearch && matchesStatus;
    });
  }, [userList, searchTerm, statusFilter]);

  const handleModalShowHide = (item) => {
    setSelectedObj(item);
    setShowHide(!showHide);
    if (showHide) {
      refetchPartnerUsers();
    }
  };

  const handlePermissionModalShowHide = (id) => {
    setPermissionShowHide(!permissionShowHide);
    if (permissionShowHide) {
      refetchPartnerUsers();
    }
  };

  const handleLogShowHide = (item, type) => {
    setActionType(type);
    setSelectedObj(item);
    setLogShowHide(!logShowHide);
    if (logShowHide) {
      refetchPartnerUsers();
    }
  };

  const getValidUserId = (item) => {
    if (!item) return "";
    if (item.fuid) return item.fuid;
    if (item.id) return item.id;

    const username = item.userName || item.username || item.name || item.performername || item.email || "";
    const performerId = item.performerid || item.performerId || item.userId || item.linkUser || "";

    if (username && performerId) {
      const prefix = username.slice(0, 3);
      return `${prefix}${performerId}`;
    }

    return performerId || username || "";
  };

  const handlePermissionShowHide = (item) => {
    if (item) {
      const validId = getValidUserId(item);
      if (validId) {
        setSelectedId(validId);
        setPermissionShowHide(!permissionShowHide);
      } else {
        getAlert("error", "The valid ID of user is missing");
      }
    } else {
      setSelectedId("");
      setPermissionShowHide(!permissionShowHide);
    }
  };

  const getStatusStyles = (status) => {
    if (status === true) {
      return {
        ...MANAGE_USERS_STYLES.statusPill,
        backgroundColor: "#ecfdf5",
        color: "#047857",
        borderColor: "#a7f3d0"
      };
    }
    if (status === false) {
      return {
        ...MANAGE_USERS_STYLES.statusPill,
        backgroundColor: "#fef2f2",
        color: "#b91c1c",
        borderColor: "#fecaca"
      };
    }
    return {
      ...MANAGE_USERS_STYLES.statusPill,
      backgroundColor: "#fffbeb",
      color: "#b45309",
      borderColor: "#fde68a"
    };
  };

  return (
    <React.Fragment>
      <style>{`
        .manage-user-card:hover {
          transform: translateY(-2px);
          border-color: rgba(191, 219, 254, 0.9) !important;
          box-shadow: 0 10px 25px rgba(37, 99, 235, 0.07) !important;
        }

        .manage-users-action:hover {
          background-color: #dbeafe !important;
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(37, 99, 235, 0.12);
        }

        .manage-users-hero-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 12px 28px rgba(37, 99, 235, 0.35) !important;
        }
      `}</style>

      <div style={MANAGE_USERS_STYLES.shell}>
        <div style={MANAGE_USERS_STYLES.hero}>
          <div style={MANAGE_USERS_STYLES.heroRow}>
            <div style={MANAGE_USERS_STYLES.heroCopy}>
              <div style={MANAGE_USERS_STYLES.heroTitleRow}>
                <span style={MANAGE_USERS_STYLES.heroIcon}>
                  <i className="fa fa-users" aria-hidden="true"></i>
                </span>
                <div>
                  <h1 style={MANAGE_USERS_STYLES.heroTitle}>Manage Users</h1>
                  <p style={MANAGE_USERS_STYLES.heroText}>
                    Review account access, monitor activation status, edit user records, and manage permissions from one workspace.
                  </p>
                </div>
              </div>
            </div>

            <div style={MANAGE_USERS_STYLES.filterRow}>
              <div style={MANAGE_USERS_STYLES.inputWrap}>
                <i className="fa fa-search" style={MANAGE_USERS_STYLES.inputIcon}></i>
                <input
                  type="text"
                  placeholder="Search name, email, ID, role, state"
                  value={searchTerm}
                  onChange={(event) => setSearchTerm(event.target.value)}
                  style={MANAGE_USERS_STYLES.searchInput}
                />
              </div>
              <select
                value={statusFilter}
                onChange={(event) => setStatusFilter(event.target.value)}
                style={MANAGE_USERS_STYLES.select}
              >
                <option value="all">All statuses</option>
                <option value="active">Activated</option>
                <option value="inactive">Deactivated</option>
                <option value="pending">Pending</option>
              </select>
              <button
                type="button"
                className="manage-users-hero-btn"
                style={MANAGE_USERS_STYLES.heroAction}
                onClick={() => handleModalShowHide("")}
              >
                <i className="fa fa-user-plus"></i> Add User
              </button>
            </div>
          </div>
        </div>

        <div style={MANAGE_USERS_STYLES.statGrid}>
            <div className="manage-user-card" style={MANAGE_USERS_STYLES.statCard}>
              <div style={MANAGE_USERS_STYLES.statIcon}>
                <i className="fa fa-users" aria-hidden="true"></i>
              </div>
              <div style={MANAGE_USERS_STYLES.statContent}>
                <div style={MANAGE_USERS_STYLES.statLabel}>Total Users</div>
                <div style={MANAGE_USERS_STYLES.statValue}>{userList.length}</div>
              </div>
            </div>
            <div className="manage-user-card" style={MANAGE_USERS_STYLES.statCard}>
              <div style={{ ...MANAGE_USERS_STYLES.statIcon, background: "#ecfdf5", color: "#047857" }}>
                <i className="fa fa-check-circle" aria-hidden="true"></i>
              </div>
              <div style={MANAGE_USERS_STYLES.statContent}>
                <div style={MANAGE_USERS_STYLES.statLabel}>Active</div>
                <div style={MANAGE_USERS_STYLES.statValue}>{activeUsersCount}</div>
              </div>
            </div>
            <div className="manage-user-card" style={MANAGE_USERS_STYLES.statCard}>
              <div style={{ ...MANAGE_USERS_STYLES.statIcon, background: "#fef2f2", color: "#b91c1c" }}>
                <i className="fa fa-ban" aria-hidden="true"></i>
              </div>
              <div style={MANAGE_USERS_STYLES.statContent}>
                <div style={MANAGE_USERS_STYLES.statLabel}>Inactive</div>
                <div style={MANAGE_USERS_STYLES.statValue}>{inactiveUsersCount}</div>
              </div>
            </div>
            <div className="manage-user-card" style={MANAGE_USERS_STYLES.statCard}>
              <div style={{ ...MANAGE_USERS_STYLES.statIcon, background: "#fffbeb", color: "#b45309" }}>
                <i className="fa fa-clock-o" aria-hidden="true"></i>
              </div>
              <div style={MANAGE_USERS_STYLES.statContent}>
                <div style={MANAGE_USERS_STYLES.statLabel}>Pending</div>
                <div style={MANAGE_USERS_STYLES.statValue}>{pendingUsersCount}</div>
              </div>
            </div>
          </div>

          <div style={MANAGE_USERS_STYLES.cardBody}>
            <div style={MANAGE_USERS_STYLES.tableWrap}>
              <table style={MANAGE_USERS_STYLES.table}>
                <thead>
                  <tr>
                    <th style={MANAGE_USERS_STYLES.th}>ID</th>
                    <th style={MANAGE_USERS_STYLES.th}>Date & Time</th>
                    <th style={MANAGE_USERS_STYLES.th}>User Details</th>
                    <th style={MANAGE_USERS_STYLES.th}>Role</th>
                    <th style={MANAGE_USERS_STYLES.th}>State</th>
                    <th style={MANAGE_USERS_STYLES.th}>Status</th>
                    <th style={MANAGE_USERS_STYLES.th}>Action</th>
                    <th style={MANAGE_USERS_STYLES.th}>Permission</th>
                  </tr>
                </thead>

                <tbody>
                  {filteredUsers.map((item) => {
                    const isCurrentUser = userDetails?.performername === item.name;
                    const initial = (item.name ? item.name.charAt(0) : "U").toUpperCase();

                    const renderStatusButton = () => {
                      const iconStyle = { fontSize: "12px" };
                      const style = getStatusStyles(item.status);

                      let label = "To Activate";
                      let icon = "fa-clock-o";
                      if (item.status === true) {
                        label = "Activated";
                        icon = "fa-check";
                      } else if (item.status === false) {
                        label = "Deactivated";
                        icon = "fa-times";
                      }

                      if (isCurrentUser) {
                        return (
                          <span style={style}>
                            <i className={`fa ${icon}`} style={iconStyle}></i> {label}
                          </span>
                        );
                      }

                      return (
                        <button
                          type="button"
                          className="btn btn-sm manage-users-action"
                          onClick={() => handleLogShowHide(item, "action")}
                          style={{
                            ...style,
                            cursor: "pointer",
                            boxShadow: "0 2px 6px rgba(15, 23, 42, 0.05)"
                          }}
                        >
                          <i className={`fa ${icon}`} style={iconStyle}></i> {label}
                        </button>
                      );
                    };

                    return (
                      <tr key={item.id}>
                        <td style={MANAGE_USERS_STYLES.td}>{item.id}</td>
                        <td style={MANAGE_USERS_STYLES.td}>
                          <div style={MANAGE_USERS_STYLES.userName}>
                            <Moment format="MMM Do YYYY">{item.addedDateTime}</Moment>
                          </div>
                          <div style={MANAGE_USERS_STYLES.userMeta}>
                            <Moment format="h:mm a">{item.addedDateTime}</Moment>
                          </div>
                        </td>
                        <td style={MANAGE_USERS_STYLES.td}>
                          <div style={MANAGE_USERS_STYLES.userCell}>
                            <div style={MANAGE_USERS_STYLES.userAvatar}>
                              {initial}
                            </div>
                            <div>
                              <div style={MANAGE_USERS_STYLES.userName}>
                                {item.name} {item.lastName}
                              </div>
                              <div style={MANAGE_USERS_STYLES.userMeta}>{item.email}</div>
                              <div style={MANAGE_USERS_STYLES.userMeta}>
                                {item.contact ? getFormatedNumber(item.contact) : "No phone on file"}
                              </div>
                            </div>
                          </div>
                        </td>
                        <td style={MANAGE_USERS_STYLES.td}>
                          <span style={MANAGE_USERS_STYLES.rolePill}>{item.title || "User"}</span>
                        </td>
                        <td style={MANAGE_USERS_STYLES.td}>{item.state || "-"}</td>
                        <td style={MANAGE_USERS_STYLES.td}>{renderStatusButton()}</td>
                        <td style={MANAGE_USERS_STYLES.td}>
                          <div style={MANAGE_USERS_STYLES.actionGroup}>
                            <button
                              type="button"
                              className="btn btn-sm manage-users-action"
                              title="Edit User"
                              onClick={() => handleModalShowHide(item)}
                              style={MANAGE_USERS_STYLES.actionBtn}
                            >
                              <i className="fa fa-pencil"></i> Edit
                            </button>
                          </div>
                        </td>
                        <td style={MANAGE_USERS_STYLES.td}>
                          {!isCurrentUser && (
                            <div style={MANAGE_USERS_STYLES.actionGroup}>
                              <button
                                type="button"
                                className="btn btn-sm manage-users-action"
                                onClick={() => handlePermissionShowHide(item)}
                                style={MANAGE_USERS_STYLES.actionBtn}
                              >
                                <i className="fa fa-shield"></i> Permissions
                              </button>
                            </div>
                          )}
                          {isCurrentUser && (
                            <span style={MANAGE_USERS_STYLES.mutedAction}>Current user</span>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                  {filteredUsers.length === 0 && (
                    <tr>
                      <td colSpan="8" style={MANAGE_USERS_STYLES.emptyState}>
                        No users matched the current search or status filter.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
      </div>

      {selectedId && (
        <AddEditPermission
          roleid={selectedId}
          roleSource="partner"
          handlePermissionShowHide={handlePermissionShowHide}
          showHide={permissionShowHide}
          handleModalShowHide={handlePermissionModalShowHide}
        />
      )}
      <AddPartnerUser
        showHide={showHide}
        handleModalShowHide={handleModalShowHide}
        currentUser={currentUser}
        selectedObj={selectedObj}
        userDetails={userDetails}
      ></AddPartnerUser>
      <ActiveDeactiveHistory
        logShowHide={logShowHide}
        handleLogShowHide={handleLogShowHide}
        selectedObj={selectedObj}
        type="performer"
        pageType="User"
        actionType={actionType}
      ></ActiveDeactiveHistory>
    </React.Fragment>
  );
};

export default ManagePartnerUsers;
